export const upsertTemplate = (templates, savedTemplate) => {
  if (!savedTemplate?.id) return Array.isArray(templates) ? templates : [];
  const current = Array.isArray(templates) ? templates : [];
  return [savedTemplate, ...current.filter((template) => String(template?.id) !== String(savedTemplate.id))];
};

export const shouldHydrateSelectedTemplate = ({ force = false, selectedTemplateId, lastHydratedTemplateId }) => (
  Boolean(force)
  || String(selectedTemplateId || '') !== String(lastHydratedTemplateId || '')
);

export const shouldUsePublishedTemplateState = ({ selectedTemplate, activeTemplateId, force = false }) => (
  selectedTemplate?.visibility !== 'private'
  && Boolean(activeTemplateId)
  && String(selectedTemplate?.id || '') === String(activeTemplateId)
  && !force
);

const stableJson = (value) => JSON.stringify(value, (_key, nestedValue) => (
  nestedValue && typeof nestedValue === 'object' && !Array.isArray(nestedValue)
    ? Object.keys(nestedValue).sort().reduce((sorted, key) => ({ ...sorted, [key]: nestedValue[key] }), {})
    : nestedValue
));

export const cloneBuilderValue = (value) => JSON.parse(JSON.stringify(value));

export const validateSavedDraftDocument = ({ savedTemplate, expectedLayoutSchema }) => {
  const persistedLayout = savedTemplate?.defaults?.layout_schema;
  if (!persistedLayout || stableJson(persistedLayout) !== stableJson(expectedLayoutSchema)) {
    throw new Error('The template service did not return the complete saved builder document.');
  }
  return true;
};

/**
 * Persist the builder document without applying it to WordPress.
 * Public templates are forked once; private templates are always updated in place.
 */
export const persistBuilderDraft = async ({
  axiosClient,
  templatesUrl,
  headers,
  selectedTemplate,
  createTemplateId,
  createName,
  defaults,
  status,
}) => {
  const isPrivate = selectedTemplate?.visibility === 'private';
  const templateId = isPrivate ? selectedTemplate.id : createTemplateId();
  const body = {
    name: isPrivate ? selectedTemplate.name : createName,
    description: isPrivate ? selectedTemplate.description : 'Instance-only template',
    status,
    ...(isPrivate ? {} : { id: templateId, visibility: 'private' }),
    defaults: {
      ...(isPrivate ? selectedTemplate.defaults || {} : {}),
      ...defaults,
    },
  };

  const response = isPrivate
    ? await axiosClient.put(`${templatesUrl}/${templateId}`, body, headers)
    : await axiosClient.post(templatesUrl, body, headers);
  const savedTemplate = response?.data?.template;

  if (!savedTemplate?.id) {
    throw new Error('The template service did not return the saved draft.');
  }
  validateSavedDraftDocument({ savedTemplate, expectedLayoutSchema: defaults?.layout_schema });

  return { template: savedTemplate, selectedTemplateId: savedTemplate.id, created: !isPrivate };
};
